import * as React from "react";
const WasteConsciousSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#040919"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#040919"
      strokeOpacity={0.03}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#040919"
      d="M37.625 19.25H33.25v-.875a2.625 2.625 0 0 0-2.625-2.625h-5.25a2.625 2.625 0 0 0-2.625 2.625v.875h-4.375a.875.875 0 1 0 0 1.75h.875v15.75A1.75 1.75 0 0 0 21 38.5h14a1.75 1.75 0 0 0 1.75-1.75V21h.875a.875.875 0 1 0 0-1.75ZM24.5 18.375a.875.875 0 0 1 .875-.875h5.25a.875.875 0 0 1 .875.875v.875h-7v-.875ZM35 36.75H21V21h14v15.75Zm-8.75-11.375v7a.875.875 0 1 1-1.75 0v-7a.875.875 0 1 1 1.75 0Zm5.25 0v7a.875.875 0 1 1-1.75 0v-7a.875.875 0 1 1 1.75 0Z"
    />
  </svg>
);
export default WasteConsciousSVG;
